<template>
  <div class="banner-header">
    <div class="filter-banner-header">
      <b-row class="d-flex align-items-lg-center align-items-center h-100">
        <b-col>
          <b-container>
            <b-row>
              <b-col>
                <h1 class="banner-title text-uppercase">
                  <b-row>
                    <b-col class="d-flex justify-content-center">
                      <span class="welcome-title-part title-part"
                        >Velkommen til Danmarks mest</span
                      >
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="main-title-part title-part my-2">
                        Intelligente
                        <span class="fellowship-title-part"
                          >Handelsfælleskab</span
                        >
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col class="d-flex justify-content-center">
                      <span class="guarantee-title-part title-part"
                        >Vi tilfører din virksomhed nye kunder
                        <b-icon-dash></b-icon-dash> med garanti</span
                      >
                    </b-col>
                  </b-row>
                </h1>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-row>
                  <b-col class="d-flex justify-content-center py-2">
                    <span
                      class="wistia_embed popover=true popoverContent=link"
                      :class="wistiaId"
                      style="display: inline; position: relative"
                    >
                      <a href="#">
                        <img
                          class="video-banner-play"
                          :src="require('@/assets/img/play.svg')"
                          alt="Afspilningsikon, klik for at se video"
                          @click="playVideo"
                        /> </a
                    ></span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="d-flex justify-content-center">
                    <p class="video-banner-play-text text-uppercase">
                      Se video om Absi
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoBanner",
  data() {
    return {
      wistiaId: "wistia_async_" + process.env.VUE_APP_ABSI_WISTIA_VIDEO_ID,
    };
  },
  methods: {
    playVideo() {
      window._wq = window._wq || [];
      window._wq.push({
        id: process.env.VUE_APP_ABSI_WISTIA_VIDEO_ID,
        onReady: function () {
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-header {
  max-width: 100%;
  background-image: url("../assets/img/Header.jpg");
  background-size: cover;
  background-position: 50% 50%;
  min-height: 273px;
  height: 50vh;

  .filter-banner-header {
    background-color: rgba(0, 0, 0, 0.44);
    height: 100%;
    padding: 15px;

    .banner-title {
      color: $secondary;
      text-align: center;

      .welcome-title-part,
      .guarantee-title-part {
        font-size: $title-paragraphs-mobile;
      }

      .main-title-part {
        font-family: $medium;
        font-size: $title-h1-mobile;
      }

      .fellowship-title-part {
        color: $primary;
      }
    }

    .video-banner-play {
      cursor: pointer;
      width: 60px;
      height: 60px;
      margin-top: 5px;
      -webkit-transition: all 0.3s ease;
      -moz-transition: all 0.3s ease;
      -o-transition: all 0.3s ease;
      -ms-transition: all 0.3s ease;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.1);
      }
    }

    .video-banner-play-text {
      color: $secondary;
      margin-top: 10px;
    }
  }
}


@media (min-width: 768px) {
  .main-title-part {
    font-size: $title-h1-desktop !important;
  }

  .welcome-title-part,
  .guarantee-title-part {
    font-size: $title-paragraphs-desktop !important;
  }
}
</style>